export default __webpack_public_path__ + "static/media/Victor Ehinmowo.0aaccf27.png";